<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let items = [];
    export let defaults = null;
    export let selectedId = null;
    export let placeholder = 'Поиск...';

    let searchQuery = items.find(i => i.idUrllico === defaults)?.name ?? '';
    let isOpen = false;
    let selectedName = '';
    let isTyping = false; // блокирует перезапись поля во время ручного ввода
    // Подставляем имя выбранного клиента, только если пользователь сейчас НЕ печатает

    $: console.log('selectedId:', selectedId, typeof selectedId, 'items:', items.map(i => [i.idUrllico, typeof i.idUrllico]));


    $: if (!isTyping && selectedId != null && items.length) {
        const item = items.find(i => +i.idUrllico === +selectedId);
        if (item?.name) {
            searchQuery = item.name;
            selectedName = item.name;
        }
    }

    $: filteredItems = items.filter(item =>
        item?.name?.toLowerCase().includes((searchQuery ?? '').toLowerCase())
    );

    $: hasSelection = !!searchQuery && selectedId !== null;

    function selectItem(item) {
        if (!item?.name) return;
        isTyping = false;
        selectedName = item.name;
        searchQuery = item.name;
        isOpen = false;
        dispatch('select', { id: item.idUrllico });
    }

    function clearSelection() {
        isTyping = false;
        searchQuery = '';
        isOpen = false;
        dispatch('select', { id: null });
    }

    function handleInput() {
        isTyping = true;
        isOpen = true;
        if (!searchQuery) dispatch('select', { id: null });
    }

    function handleBlur() {
        setTimeout(() => {
            isOpen = false;
            isTyping = false; // после закрытия можно снова подставлять имя из selectedId
        }, 200);
    }
</script>

<div class="wrapper">
    <div class="search-wrap">
        <input
                type="text"
                class="form-control"
                {placeholder}
                bind:value={searchQuery}
                on:input={handleInput}
                on:focus={() => (isOpen = true)}
                on:blur={handleBlur}
        />
        {#if hasSelection}
            <button type="button" class="clear-btn" aria-label="Очистить" on:click={clearSelection}>✕</button>
        {/if}
    </div>
    {#if isOpen && filteredItems.length > 0}
        <ul class="dropdown">
            {#each filteredItems as item}
                <li on:click={() => selectItem(item)}>{item.name}</li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .wrapper { position: relative; }
    .search-wrap { position: relative; display: flex; align-items: center; }
    .search-wrap .form-control { padding-right: 32px; }
    .clear-btn { position: absolute; right: 10px; background: none; border: none; cursor: pointer; color: #9ca3af; font-size: 14px; line-height: 1; padding: 0; display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 50%; transition: background 0.15s, color 0.15s; }
    .clear-btn:hover { background: #f3f4f6; color: #374151; }
    .dropdown { position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #ccc; border-top: none; list-style: none; padding: 0; margin: 0; max-height: 200px; overflow-y: auto; z-index: 10; box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
    li { padding: 8px; cursor: pointer; }
    li:hover { background-color: #f0f0f0; }
</style>